// /src/firebase/firebaseConfig.js
// Firebase 초기화 (gitignore 대상 파일)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase 콘솔 > 프로젝트 설정 > 내 앱에서 확인 가능
const firebaseConfig = {
  apiKey: "AIzaSyB3RoHuTvvLdvCFKwBjEMDjb5K5DxeZ_vU",
  authDomain: "moneychat-3155a.firebaseapp.com",
  projectId: "moneychat-3155a",
  storageBucket: "moneychat-3155a.firebasestorage.app",
  messagingSenderId: "729888285922",
  appId: "1:729888285922:web:a3db9662ab0beb0aee6abb",
  measurementId: "G-822539G28J"
};

const app = initializeApp(firebaseConfig);

// 앱에서 사용하는 로그인(auth)과 데이터베이스(db)
export const auth = getAuth(app);
export const db = getFirestore(app);
